import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';

import DefaultLogoPath from '../../image/DefaultLogo.png'

const LogoFileInput = forwardRef((props, ref) => {
  const { isOver } = props;

	const hiddenFileInput = useRef(null);
  const FileInputRef = useRef();
	const [imgBase64, setImgBase64] = useState();
  const [imgFile, setImgFile] = useState();
  const [imgLocalPath, setImgLocalPath] = useState('');
  
  useImperativeHandle(ref, () => ({
    getImgBase64: () => {
      return imgBase64;
    },
    getValue: () => {
      return imgLocalPath;
    },
    setBold: () => {

    },
    reset: () => {
      setImgBase64();
      setImgFile();
      setImgLocalPath();
    }
  }));

  const handleClick = e => {
    hiddenFileInput.current.click();
    FileInputRef.current.style.borderColor = '#FF8B48';
	};
	
  const handleChange = e => { 
    var pathpoint = e.target.value.lastIndexOf('.');
    var filepoint = e.target.value.substring(pathpoint + 1, e.target.length);
    var filetype = filepoint.toLowerCase();

    if (filetype === 'jpg' || filetype === 'png' || filetype === 'jpeg') {

      // 정상적인 이미지 확장자 파일인 경우
      const reader = new FileReader();
      // setImgLocalPath(e.target.value);
      var tmp = e.target.value.split('\\');
      setImgLocalPath(tmp[tmp.length - 1]);
      reader.onloadend = () => {
        const base64 = reader.result;
        
        FileInputRef.current.style.borderColor = '#E8E8E8';
        if (base64){
          setImgBase64(base64.toString());
        }
      };
      if (e.target.files[0]) {
        reader.readAsDataURL(e.target.files[0]);
        setImgFile(e.target.files[0]);
      }
    } 
    else {
      alert('.jpeg .jpg .png 파일만 가능합니다!');
    }

		
	};
  
  return (
    <TopLevelWrapper isOver={isOver}>
      <LogoExplanationWrapper isOver={isOver}>
        <LogoExplanation>1080x1080 권장 / jpg, png 최대 3MB</LogoExplanation>
      </LogoExplanationWrapper>
			<InputWrapper isOver={isOver}>
        <PicturePickerWrapper>
          <input type="file"
            ref={hiddenFileInput} 
            // isOver={isOver}
            tabIndex={-1}
            onChange={handleChange}
            style={{display: 'none'}}
            isOver={isOver}/>
          <FileInput ref={FileInputRef} isOver={isOver}>{imgLocalPath}</FileInput>
          <CheckButton onClick={handleClick}>
            <CheckMessage>찾아보기</CheckMessage>
          </CheckButton>
        </PicturePickerWrapper>
        <LogoWrapper isOver={isOver}>
          <Logo src={imgFile ? imgBase64 : DefaultLogoPath} isOver={isOver}/>
        </LogoWrapper>
      </InputWrapper>
    </TopLevelWrapper>
  );
})

export default LogoFileInput;

const TopLevelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  width: 100%;
`;

const LogoExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  // flex-wrap: wrap;

  // bwidth: ${props => props.isOver ? `max(278px, 36.19791666666667vw)` : `max(140px, 24.375vw)`};
`;

const LogoExplanation = styled.p`
	font-family: NotoSansKR-Regular;
	font-size: 14px;

	// margin: 8px 0 0 0;
  margin: 0;

	color: rgba(203, 203, 203, 1);
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.isOver ? 'row' : 'column')};
  align-items: ${(props) => (props.isOver ? 'flex-end' : 'flex-start')};

  gap: 8px;

  width: 100%;
`;

const FileInput = styled.div`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  padding: 0 4px 4px 0;
  margin-top: 23px;
  min-height: 16px;

  // width: 233px;
  width: 100%;
  
  border: 1px solid;
  border-width: 0 0 1px 0;
  border-color: #E8E8E8;
  color: #000000;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ::placeholder {
    color: ${props => props.clickCount < 1 || props.value !== '' ? `#CBCBCB` : `#FF3131;`};
  }

  transition: all 0.5s ease-in-out;
`;

const PicturePickerWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  flex: 1;

  width: 100%;
`;

const CheckButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 84px;
  height: 32px;

  border-radius: 8px 8px 0 0;
  background-color: #FF8B48;

  &:hover {
    cursor: pointer;
  }
`;

const CheckMessage = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: #FFFFFF;

  margin: 0;
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: ${(props) => (props.isOver ? '110px' : '96px')};
  height: ${(props) => (props.isOver ? '110px' : '96px')};

  border-radius: 10px;
  overflow: hidden;
`;

const Logo = styled.img`
  width: 100%;
  height: 100%;

  object-fit: cover;
  object-position: center;

  border-radius: 10px;
`;